import { changeModalState, changeToasterState, toggleModal, toggleOverLayer } from '../../../Store/layoutSlice';
import { useAppDispatch } from '../../../Store/store';
import { MODAL_STATE, TOASTER_STATE } from '../../../Model/Enums';
import { useLazyPostUserFlowInitQuery } from '../../../Store/aggreg8';
import { FlowType } from '../../../Model/UserFlow';

export const useOuterApiPanel = () => {
  const dispatch = useAppDispatch();

  const [postUserFlowInit] = useLazyPostUserFlowInitQuery();

  const handleSzamlazzhu = () => {
    dispatch(changeModalState(MODAL_STATE.SZAMLAZZHU));
  };

  // TODO refactor
  const handleAggreg8 = async (isRefresh: boolean, accountId: string) => {
    try {
      if (!isRefresh) {
        dispatch(toggleModal());
        dispatch(toggleOverLayer(true));
        await postUserFlowInit({
          flowType: FlowType.ADD_BANK,
          accountId: null,
        }).unwrap();
      }
      if (isRefresh) {
        dispatch(toggleOverLayer(true));
        await postUserFlowInit({
          flowType: FlowType.EXTEND_CONSENT,
          accountId,
        }).unwrap();
      }
    } catch (e) {
      dispatch(toggleOverLayer(false));
      dispatch(changeToasterState(TOASTER_STATE.AGGREG8_API_CONNECT_FAILED));
    }
  };

  const closeDialog = () => {
    dispatch(toggleModal());
  };

  return { handleSzamlazzhu, handleAggreg8, closeDialog };
};
